export default {
  createVariable: 'Definovať novú premennú',
};
